import { useTranslation } from 'react-i18next';
import { AlertCircle, RefreshCw } from 'lucide-react';
import Button from '@components/atoms/ui-kit/button';
import { useThemeContext } from '@utils/providers/theme-context.tsx';

/**
 * Inline card shown when the chosen connection was authorized under
 * the captions-only scope. The user clicks Reconnect which closes
 * the dialog and routes to the connect wizard (orchestrated by the
 * parent); the reconnect flow preserves defaults and asks Google for
 * the ``youtube.upload`` scope on top of ``youtube.force-ssl``.
 */
export default function ReconnectForUploadNotice({
  onReconnect
}: {
  onReconnect?: () => void;
}) {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();
  return (
    <div
      role="alert"
      className="flex items-start gap-3 rounded-xl border p-4"
      style={{
        borderColor: getColour('hairline'),
        background: getColour('secondLayer')
      }}
    >
      <AlertCircle
        className="h-5 w-5 shrink-0 mt-0.5"
        aria-hidden="true"
        style={{ color: getColour('inactiveText') }}
      />
      <div className="flex flex-col gap-2">
        <p className="text-sm font-medium">
          {t('publish-new-video-reconnect-title')}
        </p>
        <p className="text-xs" style={{ color: getColour('inactiveText') }}>
          {t('publish-new-video-reconnect-help')}
        </p>
        {onReconnect && (
          <Button
            variant="primary"
            size="small"
            label={t('publish-new-video-reconnect-cta')}
            icon={<RefreshCw className="h-4 w-4" aria-hidden="true" />}
            onClick={onReconnect}
          />
        )}
      </div>
    </div>
  );
}
